import { Button } from 'antd';
import { Buttons } from './styles/button.style';

const AntButton = Buttons(Button);

export default AntButton;


// WEBPACK FOOTER //
// ./src/components/UI/Button.js